import { toast } from "react-toastify";
import * as api from "../../api/api";
import { auth } from "../type";
import { resetUserState } from "./userDetails";
import { getEos } from "../../service/eosconfig";
import { login } from "../../service/alacrityService";
import ToastifyIconComponent from "../../components/Common/ToastifyIconComponent";
import React from "react";
import { setStoredUser, setStoredWallet } from "../../utils/storedUser";

export const setRPC = (payload) => ({
  type: auth.SET_RPC,
  payload,
});

export const setAuthenticationToken = (payload) => ({
  type: auth.SET_AUTH_TOKEN,
  payload,
});

export const setUserDetails = (payload) => ({
  type: auth.SET_USER_DETAILS,
  payload,
});

export const setCustodianLimits = (payload) => ({
  type: auth.SET_LIMITS,
  payload,
});

export const getCustodianLimits = () => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if(token){
    api
    .getCustodianLimits(config)
    .then((response) => {
      setStoredUser(response?.data?.data);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
      //TODO: move all logic to custodian limits
      dispatch(
        setCustodianLimits({
          freeLimit: response?.data?.data?.freeLimit,
          tiedLimit: response?.data?.data?.tiedLimit,
          businessLimit:response?.data?.data?.businessLimit,
          currency: response?.data?.data?.depositCurrencies[0],
          freeLimitInUsd: response?.data?.data?.freeLimitInUsd,
          tiedLimitInUsd: response?.data?.data?.tiedLimitInUsd,
          tiedLimitInLocalCurrency: response?.data?.data?.tiedLimitInLocalCurrency,
          freeLimitInLocalCurrency: response?.data?.data?.freeLimitInLocalCurrency,
        })
      );
    })
    .catch((err) => {
    })
  }
};

export const getCustodianLimitsFromDb = () => (dispatch, getState) => {
  const state = getState();
  const token = state?.Authentication?.token;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  if (token) {
    api
      .getCustodianLimitsFromDb(config)
      .then((response) => {
        setStoredUser(response?.data?.data);
        dispatch(setUserDetails(JSON.stringify(response?.data?.data)));
        dispatch(
          setCustodianLimits({
            freeLimit: response?.data?.data?.freeLimit,
            tiedLimit: response?.data?.data?.tiedLimit,
            businessLimit: response?.data?.data?.businessLimit,
            currency: response?.data?.data?.depositCurrencies?.[0],
            freeLimitInUsd: response?.data?.data?.freeLimitInUsd,
            tiedLimitInUsd: response?.data?.data?.tiedLimitInUsd,
            tiedLimitInLocalCurrency:
              response?.data?.data?.tiedLimitInLocalCurrency,
            freeLimitInLocalCurrency:
              response?.data?.data?.freeLimitInLocalCurrency,
          }),
        );
      })
      .catch(() => {});
  }
};
  
export const setUserWallet = (payload) => ({
  type: auth.SET_WALLET_DETAILS,
  payload,
});

export const setAuthError = (payload) => ({
  type: auth.SET_AUTH_ERROR,
  payload,
});

export const setForgetPasswordOTP = (payload) => ({
  type: auth.SET_PASSWORD_OTP,
  payload,
});

export const setUserStatus = (payload) => ({
  type: auth.SET_USER_STATUS,
  payload,
});

export const setRegisterOTPSent = (payload) => ({
  type: auth.SET_REGISTER_OTP_SENT,
  payload,
});

export const setResendOTP = (payload) => ({
  type: auth.SET_RESEND_OTP,
  payload,
});

export const setResetPasswordSuccess = (payload) => ({
  type: auth.SET_RESET_PASSWORD_SUCCESS,
  payload,
});

export const setLoginOTP = (payload) => ({
  type: auth.SET_LOGIN_OTP,
  payload,
});

export const setLoginResponse = (payload) => ({
  type: auth.SET_LOGIN_RESPONSE,
  payload,
});

export const setLoginLoader = (payload) => ({
  type: auth.SET_LOGIN_LOADER,
  payload,
});

export const resetAuthState = () => ({
  type: auth.RESET_AUTH_STATE,
});

export const setAlacrityAccountDetails = (payload) => ({
  type: auth.SET_ACCOUNT_DETAILS,
  payload,
});

export const openMnemonicsPopup = (payload) => ({
  type: auth.OPEN_MNEMONICS_POPUP,
  payload,
});

export const closeMnemonicsPopup = (payload) => ({
  type: auth.CLOSE_MNEMONICS_POPUP,
  payload,
});

export const logout = () => async (dispatch, getState) => {
  // Leave every chat room joined as this account: the socket outlives the
  // login, and the server keys its room checks on who joined (midl-server
  // ROUTER-DISPUTE-DRAIN-FIX-PLAN §14). A reconnect starts in no rooms.
  const socket = getState?.()?.UserDetails?.socketInstance;
  if (socket?.connected && typeof socket.disconnect === "function") {
    socket.disconnect();
    socket.connect();
  }
  dispatch(resetAuthState());
  dispatch(resetUserState());
  indexedDB.deleteDatabase("MIDL_APP");
  localStorage.removeItem("alacrity");
  localStorage.removeItem("Token");
  localStorage.removeItem("User");
  localStorage.removeItem("User Wallet");
  window.localStorage.clear();
  localStorage.setItem("isLogout", true);
};

export const registerUser = (verifyEmail, data) => (dispatch) => {
  api
    .signupUser(verifyEmail, data)
    .then((response) => {
      setStoredUser(response?.data?.data?.user);
      setStoredWallet(response?.data?.data?.userWallet);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data?.user)));
      dispatch(setUserWallet(JSON.stringify(response?.data?.data?.userWallet)));
      dispatch(setAuthError(""));
      toast.success(<div className="content">Congratulations. You are registered.</div>, {
        icon: () => (<ToastifyIconComponent />), 
        className: "midl-toast"
       });
      dispatch(setRegisterOTPSent(true));
    })
    .catch((err) => {
      dispatch(setRegisterOTPSent(false));
    });
};

export const loginUser = (data) => async (dispatch) => {
  const { userRole } = data;
  const res = await login(data.password, data?.mnemonic);
  if (!res) {
    // toast.error("The password you've entered is incorrect. Please try again or logout and login again using your mnemonic.");
    dispatch(setLoginLoader(false));
    return;
  }
  const { username, publicKey, signature, privateKey } = res;
  let payload = {
    username,
    publicKey: publicKey,
    signature: signature,
    userRole,
  };
  api
    .signinUser(payload)
    .then((response) => {
      dispatch(setLoginLoader(false));
      localStorage.setItem("Token", response?.data?.data?.accessToken);
      dispatch(setAuthenticationToken(response?.data?.data?.accessToken));
      setStoredUser(response?.data?.data?.user);
      dispatch(setUserDetails(JSON.stringify(response?.data?.data?.user)));
      setStoredWallet(response?.data?.data?.userWallet);
      localStorage.setItem("isLogout", false);
      dispatch(setUserWallet(JSON.stringify(response?.data?.data?.userWallet)));
      dispatch(setAuthError(""));
      dispatch(setRPC(getEos(privateKey)));
      toast.success(<div className="content">Congratulations. You are logged in.</div>, {
          icon: () => (<ToastifyIconComponent/>),
          className: "midl-toast",
      });
    })
    .catch((err) => {
      dispatch(setLoginLoader(false));
      localStorage.removeItem("alacrity");
    });
};

export const generatePasswordOTP = (data) => (dispatch) => {
  api
    .generateOTP(data)
    .then((response) => {
      dispatch(setForgetPasswordOTP(true));
    })
    .catch((err) => {
      dispatch(setForgetPasswordOTP(false));
    });
};

export const verifyUser = (data) => (dispatch) => {
  dispatch(setUserStatus(false));
  api
    .verifyUser(data)
    .then((response) => {
      dispatch(setUserStatus(true));
    })
    .catch((err) => {
      dispatch(setUserStatus(false));
    });
};

export const resendOTP = (data) => (dispatch) => {
  api
    .resendOTP(data)
    .then((response) => {
      toast.success(<div className="content">Verification code sent</div>, {
        icon: () => (<ToastifyIconComponent />), 
        className: "midl-toast"
       });
    })
    .catch((err) => {
      console.log(err);
    });
};

export const resetPassword = (data) => (dispatch) => {
  api
    .resetPassword(data)
    .then((response) => {
      dispatch(setResetPasswordSuccess(true));
      toast.success(<div className="content">Password changed successfully</div>, {
        icon: () => (<ToastifyIconComponent />), 
        className: "midl-toast"
       });
    })
    .catch((err) => {
      dispatch(setResetPasswordSuccess(false));
    });
};
